import {Button, Table} from "react-bootstrap";
import {ActivationRequestItem} from "../../modal/activation-request-item";

const AddedItemsList:React.FC<{itemList:ActivationRequestItem[], removeItemHandler: (item: ActivationRequestItem) => void}> = (props) => {
    return (
        <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th>#</th>
                <th>Category:</th>
                <th>Products:</th>
                <th>Option:</th>
            </tr>
            </thead>
            <tbody>
            {props.itemList.map((item, index) => (
                <tr key={index}>
                    <td>
                        <Button variant={"danger"} onClick={() => props.removeItemHandler(item)}>Remove</Button>
                    </td>
                    <td>{item.category.name}</td>
                    <td>{item.product.name}</td>
                    <td>
                        {item.activateAll && "ALL OPTIONS"}
                        {!item.activateAll && <p>{item.options.length} OPTION/S</p>}
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    );
}

export default AddedItemsList;